// Vue
import {Component, Prop, Vue} from 'vue-property-decorator'
// Template
import template from './template.vue'

import {DashboardTile as DashboardTileData} from "../../../interfaces/DashboardTile";

@Component({
    mixins: [template]
})
export class DashboardTile extends Vue {

    @Prop()
    public tile!: DashboardTileData

    @Prop({default: false})
    public favoritesLimitReached!: boolean

    @Prop({default: false})
    public isLoggedIn!: boolean

    @Prop({default: 200})
    public tileHeight!: number

    @Prop({default: true})
    public showTileImage!: boolean

    @Prop()
    public lang!: string

    @Prop({default: false})
    public favoriteOverlayOpen!: boolean

    @Prop({default: true})
    public showBack!: boolean

    public get isTileLocked() {
        return (this.tile
                && this.tile.application_access
                && this.tile.application_access.access_required
                && !this.tile.application_access.user_has_access)
            || (this.tile && this.tile.show_company_migration_notice)
    }

    public get isAccessRequested() {
        return this.tile
            && this.tile.application_access
            && this.tile.application_access.access_required
            && this.tile.application_access.release
            && this.tile.application_access.release.in_progress_for_user;
    }

    public get tileIcon() {
        if (this.isTileLocked) {
            return this.$icons.EDIT;
        } else {
            return this.$icons.INFO;
        }
    }

    public get hasBack() {
        if (this.tile && this.tile.show_company_migration_notice) {
            return false;
        }

        return (this.tile.content && Object.keys(this.tile.content).length > 0)
            || this.isTileLocked
    }

    public get href() {
        if (this.tile && this.tile.show_company_migration_notice) {
            return '/--/--/nicht-aktiviert'
        }

        if (this.isTileLocked) {
            return '#'
        }

        return this.tile.preview['content']['link']['href']
    }

    public isIE() {
        if ( window['msCrypto'] !== undefined ) {
            return true;
        } else {
            return false;
        }
    }

    public handleFavoriteLimitClose() {
        this.$emit('favorite-overlay-closed', this.tile);
    }

    public toggleFavoriteFlag() {
        this.$emit('toggle-favorite', this.tile);
    }

    public onOpenRequestAccessDialog() {
        this.$emit('open-request-access-dialog', this.tile);
    }

    getTranslatedImage( imageObject, language, size )
    {
        let languageOrder = [language, 'en', 'de']
        for (let index = 0; index < languageOrder.length; ++index) {
            let lang = languageOrder[index];

            if (imageObject[lang]
                && imageObject[lang]['full']
                && imageObject[lang]['full'].toLowerCase().endsWith('svg'))
            {
                return imageObject[lang]['full']
            }
            // Check for normal images and size
            else if (imageObject[lang] && imageObject[lang][size]) {
                return imageObject[lang][size];
            }
        }

        return null
    }
}